import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store/index'

Vue.use(VueRouter)

const routes = [
  {
    path: '/', redirect: '/public/search',
  },
  {
    path: '/public',
    component: () => import('@/layouts/PublicLayout'),
    children: [
      { path: 'processes/:id?', name: 'processes', component: () => import(/* webpackChunkName: "process-search" */ '@/views/ProcessSearch') },
      {
        path: 'search',
        name: 'search',
        component: () => import('@/views/Search')
      },
      {
        path: 'manufacturers',
        name: 'manufacturers',
        component: () => import('@/views/Manufacturers'),
      },
      {
        path: 'manufacturer/:id?',
        name: 'manufacturer',
        props: true,
        component: () => import('@/views/Manufacturer'),
      }
    ]
  },
  {
    path: '/admin',
    component: () => import(/* webpackChunkName: "admin" */ '@/layouts/AdminLayout'),
    children: [
      { path: '', redirect: store.getters.isLoggedIn ? 'posts' : 'login'},
      { path: 'login', name: 'login', component: () => import(/* webpackChunkName: "login" */ '@/views/admin/Login') },
      { path: 'posts', name: 'posts', component: () => import(/* webpackChunkName: "posts" */ '@/views/admin/PostList') },
      {
        path: 'profile',
        name: 'profile',
        component: () => import(/* webpackChunkName: "profile" */ '@/views/admin/Profile')
      }
    ],
    beforeEnter: (to, from, next) => {
      if ( to.name !== 'login' && !store.getters.isLoggedIn) {
          next( { name: 'login' } )
      }
      if ( to.name === 'login' && store.getters.isLoggedIn) {
        next( { name: 'posts' } )
      }
      next()
    }
  },
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  store.commit('updateIsLoading', true)
  next()
})
router.afterEach(() => {
  store.commit('updateIsLoading', false)
})


export default router
